export default [
    {
        path: 'log/loginlist',
        name: 'sys_monitor_log_login_list',
        meta: {isCache: true, icon: 'md-bookmarks', hideInMenu: false},
        component: () => import('@/views/sys_monitor/log/log-loginlist.vue'),
    },
    /*{
        path: 'log/opelist',
        name: 'sys_monitor_log_ope_list',
        meta: {isCache: true, icon: 'md-albums', hideInMenu: false},
        component: () => import('@/views/sys_monitor/log/log-opelist.vue'),
    },*/
];
